import Axios from 'axios';

export default {
  create(data) {
    return Axios.post('/admin/business-rule-groups', { ...data }).then(({ response }) => response);
  },
  update(data) {
    return Axios.put(`/admin/business-rule-groups/${data.id}`, { ...data }).then(({ response }) => response);
  },
};
